import * as Yup from "yup";
import dayjs from "dayjs";

export const staffSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  contact: Yup.string().nullable(),
  research_interests: Yup.string().nullable(),
  qualifications: Yup.string().nullable(),
  institution_id: Yup.string().required("Institution is required"),
  position_id: Yup.string().required("Position is required"),
  title_id: Yup.string().required("Title is required"),
  date_started: Yup.string().nullable(),
  date_ended: Yup.string()
    .nullable()
    .test(
      "end-after-start",
      "End date must be after start date",
      function (value) {
        const { date_started } = this.parent;
        if (date_started && value) {
          return dayjs(value).isAfter(dayjs(date_started));
        }
        return true;
      }
    ),
});
